import { ComponentSize } from "@kunduz/feature-landing-pages";

export const defaultComponentSizeFields = {
  sizeDesktop: {
    type: "select",
    label: "Size Desktop",
    options: [
      { value: "xs", label: "Extra Small (xs)" },
      { value: "sm", label: "Small (sm)" },
      { value: "md", label: "Medium (md)" },
      { value: "lg", label: "Large (lg)" },
      { value: "xl", label: "XL (xl)" },
      { value: "xxl", label: "XXL (xxl)" },
    ],
  },
  sizeTablet: {
    type: "select",
    label: "Size Tablet",
    options: [
      { value: "xs", label: "Extra Small (xs)" },
      { value: "sm", label: "Small (sm)" },
      { value: "md", label: "Medium (md)" },
      { value: "lg", label: "Large (lg)" },
      { value: "xl", label: "XL (xl)" },
      { value: "xxl", label: "XXL (xxl)" },
    ],
  },
  sizeMobile: {
    type: "select",
    label: "Size Mobile",
    options: [
      { value: "xs", label: "Extra Small (xs)" },
      { value: "sm", label: "Small (sm)" },
      { value: "md", label: "Medium (md)" },
      { value: "lg", label: "Large (lg)" },
      { value: "xl", label: "XL (xl)" },
      { value: "xxl", label: "XXL (xxl)" },
    ],
  },
};

export const defaultComponentSize: {
  sizeMobile?: ComponentSize;
  sizeTablet?: ComponentSize;
  sizeDesktop?: ComponentSize;
} = {
  sizeDesktop: "md",
  sizeTablet: "md",
  sizeMobile: "md",
};
